import BasketPageOrder from "./basket-page-order";

export default BasketPageOrder;